import { useEffect, useState } from 'react';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-[#0a0f1c]">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ddf2893ca06826fb27b3b0cf757303f7.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0f1c]/60 via-[#0a0f1c]/30 to-[#0a0f1c]/80" />
      </div>

      <div className={`relative z-10 text-center px-6 max-w-5xl mx-auto transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <p className="text-teal-400 text-sm font-medium tracking-[0.2em] uppercase mb-8 opacity-90">
          Santislogix
        </p>
        <h1 className="font-serif text-7xl lg:text-8xl xl:text-9xl font-bold text-white leading-[1.0] mb-8 tracking-tight">
          Elevate Your<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-300 to-teal-500">
            Operations.
          </span>
        </h1>
        <p className={`text-xl lg:text-2xl text-white/70 mb-4 font-light max-w-2xl mx-auto leading-relaxed transition-all duration-1000 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          Intelligent, structured AI systems for service businesses that demand precision and exceptional client experience.
        </p>

        <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 mt-12 transition-all duration-1000 delay-400 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <a
            href="#consultation"
            className="bg-teal-500 text-white px-10 py-4 rounded-full text-base font-medium hover:bg-teal-400 transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wide"
          >
            Book a Strategic Elevation Call
          </a>
          <a
            href="#systems"
            className="text-white/80 text-base font-light hover:text-white transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2 group"
          >
            Explore Our Systems
            <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </a>
        </div>
      </div>

      <div className={`absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 transition-all duration-1000 delay-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}>
        <span className="text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/30 to-transparent animate-pulse" />
      </div>
    </section>
  );
}
